"use strict";
awardLetter.classy.controller({
    name: "AwardLetterSidebarController",
    inject: ["$scope", "AwardLetterTemplatesModelService"],
    init: function() {
        /*
         * Fetch templates from the API and have them wrapped with the AwardLetterTemplate class.
         * We exclude the .text property to save some memory as we don't use it here.
         */
        this.$.templates = this.AwardLetterTemplatesModelService.getWrapped({includeText: false});
        /*
         * Update this legend to change the sfs options and their outputs (field/value pairs must be unique).
         * ---
         * field: Represents the sfs option on the frontend, and becomes the name of sub-objects within the sfs object.
         *   key: Template object's index to pull data from (works with getters too).
         * value: Value used for the Angular filter (sfs sorts use booleans to indicate ascending or descending).
         * label: Frontend-friendly text for the given field.
         */
        this.$.legend = [
            {field: "letterType", key: "type", value: "", label: "All"},
            {field: "letterType", key: "type", value: "1", label: "Award"},
            {field: "letterType", key: "type", value: "0", label: "Reject"},
            {field: "createdBy", key: "user", value: "", label: "Everyone"},
            {field: "createdBy", key: "user", value: "1", label: "School"},
            {field: "createdBy", key: "user", value: "0", label: "ISM"},
            {field: "byTitle", key: "title", value: "", label: "-"},
            {field: "byTitle", key: "title", value: false, label: "A - Z"},
            {field: "byTitle", key: "title", value: true, label: "Z - A"},
            {field: "byDate", key: "date", value: "", label: "-"},
            {field: "byDate", key: "date", value: false, label: "Oldest - Newest"},
            {field: "byDate", key: "date", value: true, label: "Newest - Oldest"}
        ];
        // This is instantiated by ng-if's within the partial (allows frontend devs to inline any changes)
        this.$.sfs = {
            search: "",
            filter: {}, // {field: {key, value, label}, ...}
            sort: {} // {field: {key, value, label}, ...}
        };
    },
    /** Gets excluded templates based on matching templates
     * @param {Array.<AwardLetterTemplate>} matchingTemplates i.e. [{}, ...]
     * @returns {Array.<AwardLetterTemplate>} i.e. [{}, ...]
     */
    getExcludedTemplates: function(matchingTemplates) {
        return this.$.templates.filter((template) => {
            return matchingTemplates.find((x) => x.recordID === template.recordID) === undefined;
        });
    },
    /** Gets all filters as an object containing key/value pairs, with the title's text search tacked on
     * @returns {Object} i.e. {key: value, ...}
     */
    getSearchFilter: function() {
        let output = {title: this.$.sfs.search};
        for (let field in this.$.sfs.filter) {
            let filter = this.$.sfs.filter[field];
            output[filter.key] = filter.value;
        }
        return output;
    },
    /** Gets first sort that is set, with the boolean indicating ascending (false) or descending (true)
     * @returns {string} i.e. "-key"
     */
    getSort: function() {
        for (let field in this.$.sfs.sort) {
            let sort = this.$.sfs.sort[field];
            if (typeof sort.value === "boolean") {
                return `${sort.value ? "-" : ""}${sort.key}`;
            }
        }
        return "";
    },
    /** Gets a mapping from the legend based on field/value pair
     * @param {string} field i.e. legend[].field
     * @param {string} value i.e. legend[].value
     * @returns {Object} i.e. {field: "", key: "", value: "", label: ""}
     */
    getMapping: function(field, value) {
        return this.$.legend.find((x) => x.field === field && x.value === value);
    },
    /** Gets a label from a legend mapping based on field/value pair
     * @param {string} field i.e. legend[].field
     * @param {string} value i.e. legend[].value
     * @returns {string} i.e. "label"
     */
    getLabel: function(field, value) {
        return this.$.getMapping(field, value).label;
    },
    /** Uses field/value pair to set a filter (mapping provides key/label data)
     * @param {string} field i.e. legend[].field
     * @param {string} value i.e. legend[].value
     * @returns {void}
     */
    setFilter: function(field, value) {
        const {key, label} = this.$.getMapping(field, value);
        this.$.sfs.filter[field] = {key, value, label};
    },
    /** Uses field/value pair to set a sort (mapping provides key/label data)
     * @param {string} field i.e. legend[].field
     * @param {string} value i.e. legend[].value
     * @returns {void}
     */
    setSort: function(field, value) {
        const {key, label} = this.$.getMapping(field, value);
        this.$.sfs.sort[field] = {key, value, label};
    }
});
